import * as React from 'react';
import styled from 'styled-components';
import MuiDrawer, { DrawerProps as MuiDrawerProps } from '@material-ui/core/Drawer';

const StyledDrawer = styled(MuiDrawer)``;

export type DSDrawerProps = MuiDrawerProps;
export const DSDrawer: React.FC<DSDrawerProps> = StyledDrawer;
